/**
 * The SVG namespace to use
 * @type {string}
 */
export const SVG_NAMESPACE_NAME = "http://www.w3.org/2000/svg";